import { IntlShape, defineMessages } from "react-intl";

import { formattedMessageParams } from "shared/messages";

const {
  PropertiesSelectOneRoom,
  PropertiesSelectTwoFourRooms,
  PropertiesSelectFivePlusRooms,
} = defineMessages({
  PropertiesSelectOneRoom: formattedMessageParams("PropertiesSelect.OneRoom"),
  PropertiesSelectTwoFourRooms: formattedMessageParams(
    "PropertiesSelect.TwoFourRooms"
  ),
  PropertiesSelectFivePlusRooms: formattedMessageParams(
    "PropertiesSelect.FivePlusRooms"
  ),
});

export const correctRoomWording = (num: number, intl: IntlShape): string => {
  let wordRooms = intl.formatMessage(PropertiesSelectTwoFourRooms);
  if (num === 1) {
    wordRooms = intl.formatMessage(PropertiesSelectOneRoom);
  } else if (num >= 5 || num === 0) {
    wordRooms = intl.formatMessage(PropertiesSelectFivePlusRooms);
  }

  return wordRooms;
};
